<template>
  <div class="rightChart">
    <div class="bottomLeft">
      <!-- 标题 -->
      <div class="mapTitle">
        <div class="littleImg">
          <img src="../assets/img/littleImg.png" alt />
        </div>
        <div class="word">医药工业企业地区分布情况</div>
      </div>
      <!-- 地图 -->
      <div id="map"></div>
    </div>
    <div class="bottomRight">
      <!-- 标题 -->
      <div class="cakeTitle">
        <div class="littleImg">
          <img src="../assets/img/littleImg.png" alt />
        </div>
        <div class="word">医药工业企业经营类别分布情况</div>
      </div>
      <!-- 饼图 -->
      <div id="cake"></div>
    </div>
  </div>
</template>
<script>
import api from "@/../static/common/api/api.js";
import echarts from "echarts";
import chinaJson from "../../static/common/china.json";
export default {
  data() {
    return {};
  },
  props: ["initEchart"],
  watch: {
    initEchart(n, o) {
      this.map(); //地图
      this.drawing(); //环形
    }
  },
  methods: {
    // 中国地图
    map() {
      var mapList = [];
      api.pharmaSumMap().then(res => {
        // mapList = res.data;
        // console.log(mapList, 6666666666666);
        res.data.forEach(item => {
          var newArr = {};
          newArr.name = item.region;
          newArr.value = item.num;
          mapList.push(newArr);
        });
        // console.log(mapList, 6666666666666);
         echarts.registerMap("china", chinaJson);
        myMap.setOption(optionMap);
      });
      var myMap = echarts.init(document.getElementById("map"));
      myMap.resize();
      var optionMap = {
        tooltip: {
          //鼠标移上去时显示悬浮框
          trigger: "item",
          // backgroundColor: "transparent", //悬浮框最外层设置了默认padding;5,背景色灰色，如果要自定义，设置padding:0;或者背景色透明。
          // padding: 0,
          formatter: "{b}\n{c}家"
        },
        visualMap: {
          //图注
          left: "left",
          top: "bottom",
          textStyle: {
            color: "#fff",
            fontSize: 12,
            fontWeight: 400
          },
          text: ["高", "低"],
          inRange: {
            color: ["#87cefa", "#dfed27", "#e6521b"]
          },
          show: true
        },

        series: [
          //整体配置
          {
            name: "中国",
            type: "map",
            mapType: "china",
            // roam: true,//缩放
            zoom: 1.2,
            label: {
              normal: {
                show: true //省份名称
              }
            },

            // itemStyle: {
            //   //有2个状态  normal 是图形在默认状态下的样式；emphasis 是图形在高亮状态下的样式
            //   normal: {
            //     borderColor: "#FFFFFF", //边框颜色
            //     borderWidth: 1 //边框线宽
            //   },
            //   emphasis: {
            //     //  fontSize: "12",
            //     // fontWeight: 400,
            //     // color: "#EFF7FF",
            //     // areaColor: "#8ACFF2" //鼠标选择区域颜色
            //   }
            // },
            data: mapList
          }
        ]
      };
    },
    //   环形图
    drawing() {
      var myCake = echarts.init(document.getElementById("cake"));
      myCake.resize();
      var option = {
        tooltip: {
          trigger: "item",
          formatter: "{b}: {c}家 ({d}%)"
        },
        legend: {
          //图例
          x: "center",
          y: "top",
          left: 10,
          top: 40,
          data: [],
          textStyle: {
            color: "#fff",
            fontSize: 12,
            fontWeight: 400
          }
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ["32%", "45%"], //半径
            avoidLabelOverlap: false,
            color: [
              "#177fe8",
              "#ef7041",
              "#a8d9ab",
              "#03aab9",
              "#88cff8",
              "#ded668",
              "#c0e272"
            ],
            // color: [
            //   "#0360B9",
            //   "#03AAB9",
            //   "#0DC6D7",
            //   "#45A5F8",
            //   "#177FE8",
            //   "#0E70CE",
            //   "#F4724A"
            // ],
            label: {
              show: false,
              position: "center",
              normal: {
                //指示线指示文字
                show: true,
                position: "outside",
                formatter: "{d}%",
                textStyle: {
                  fontWeight: 400,
                  fontSize: 14,
                  color: "#fff"
                }
              }
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "26",
                fontWeight: "bold"
              }
            },
            labelLine: {
              show: false,
              normal: {
                //指示线指示文字
                show: true,
                length: 35,
                length2: 17,
                lineStyle: {
                  width: 1
                }
              }
            },
            itemStyle: {
              borderWidth: 1,
              borderColor: "#fff"
            },
            data: []
            // data: [
            //   { value: , name: "" },
            // ]
          }
        ]
      };

      let cakeList = []; //总数据
      api.pharmaSumCake().then(res => {
        cakeList = res.data;
        cakeList.forEach(item => {
          var newArr = {};
          newArr.value = item.num;
          newArr.name = item.type;
          option.legend.data.push(item.type);
          option.series[0].data.push(newArr);
        });
        myCake.setOption(option);
      });
    }
  },
  mounted() {
    this.map(); //地图
    this.drawing(); //环形
  }
};
</script>
<style scoped lang="less">
/* scrollbar */
.rightChart::-webkit-scrollbar {
  width: 5px;
  height: 10px;
}
.rightChart::-webkit-scrollbar-thumb {
  background: #3583ed;
  border-radius: 5px;
}
.rightChart::-webkit-scrollbar-track {
  background: #dfdfdf;
  border-radius: 5px;
}
/* 针对IE的scrollbar */
.rightChart {
  scrollbar-face-color: #3583ed; /*3D表面（ThreedFace）*/
  scrollbar-highlight-color: #dfdfdf; /*3D界面的亮边（ThreedHighlight）*/
  scrollbar-shadow-color: #dfdfdf; /*3D界面的暗边（ThreedShadow）*/
  scrollbar-3dlight-color: #dfdfdf; /*亮边框*/
  scrollbar-arrow-color: #3583ed; /*方向箭头 */
  scrollbar-track-color: #dfdfdf; /*拖动区域(TrackBar)*/
  scrollbar-darkshadow-color: #dfdfdf; /*暗边框（ThreedDarkShadow）*/
}
/* 针对firefox的scrollbar */
.rightChart {
  scrollbar-color: #3583ed #dfdfdf;
  scrollbar-width: thin;
}
/* Edge 的scrollbar隐藏*/
/* .rightChart{
    -ms-overflow-style:none;
} */
// 可视化
.rightChart {
  width: auto;
  height: auto;
  margin-right: 20px;
  padding: 20px 20px 50px 20px;
  display: flex;
  border: 1px solid #08396a;
  overflow: auto;
  // overflow-x: scroll;
  .bottomLeft {
    width: 62%;
    height: auto;
    display: flex;
    flex-direction: column;
    margin-right: 50px;
    //  标题
    .mapTitle {
      width: 100%;
      height: 40px;
      line-height: 40px;
      display: flex;
      border-bottom: 1px solid #08396a;
      .littleImg {
        img {
          width: 12px;
          height: 12px;
        }
      }

      .word {
        margin-left: 4px;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #dfecf7;
      }
    }
    #map {
      width: 800px;
      height: 603px;
      margin: 0 auto;
      overflow: hidden;
    }
  }
  .bottomRight {
    width: 38%;
    height: auto;
    display: flex;
    flex-direction: column;
    //  标题
    .cakeTitle {
      width: 100%;
      height: 40px;
      line-height: 40px;
      display: flex;
      border-bottom: 1px solid #08396a;
      .littleImg {
        img {
          width: 12px;
          height: 12px;
        }
      }

      .word {
        margin-left: 4px;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #dfecf7;
      }
    }
    #cake {
      width: 600px;
      height: 603px;
      margin: 0 auto;
      overflow: hidden;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/visualization.vue